import { of } from 'rxjs';

export const ctaContactPhoneMockDataQA = {
  data$: of({
    uid: 'cmsitem_00198003',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTk4MDAzIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'CTAContactComponent',
    modifiedtime: '2022-11-23T15:50:06.905+01:00',
    name: 'cta12',
    container: false,
    phoneNumber: '033-2050828',
    removeBottomSpacing: true,
    children: 'cmsitem_00144000',
    subtitle: 'Only phone filled in, no bottom',
    synchronizationBlocked: false,
    numbers: 'cmsitem_00144000',
    title: 'CTA Contact Editor',
  }),
};

export const ctaContactEmailMockDataQA = {
  data$: of({
    uid: 'cmsitem_00198002',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTk4MDAyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'CTAContactComponent',
    modifiedtime: '2022-11-23T15:50:06.904+01:00',
    name: 'conatctcta1',
    container: false,
    emailAddress: 'info@boels.com',
    phoneNumber: '0900-0551',
    removeBottomSpacing: false,
    children: 'cmsitem_00142162',
    subtitle: 'Our experts are ready to help. Please feel free to contact us.',
    phoneRate: '(local rate)',
    synchronizationBlocked: false,
    numbers: 'cmsitem_00142162',
    title: 'CTA Contact Editor',
  }),
};
